<div class="grid-1col input-grid-gaps">
    <app-select-input
        [form]="form"
        id="accountId"
        [prefix]="prefix"
        [staticOptions]="accountOptions()"
        valueKey="id"
        [disabled]="form.value.type === MadoVatCodeLineTypeEnum.BASE"
    ></app-select-input>
    <app-select-input
        [form]="form"
        id="entryType"
        [prefix]="prefix"
        [staticOptions]="madoVatCodeLineEntryTypeOptions"
    ></app-select-input>
    <app-select-input
        [form]="form"
        id="type"
        [prefix]="prefix"
        [staticOptions]="madoVatCodeLineTypeOptions"
    ></app-select-input>
    <app-number-input
        [form]="form"
        id="percentage"
        [label]="prefix + 'fields.percentage'"
        [min]="-100"
        [max]="100"
        [disabled]="form.value.type === MadoVatCodeLineTypeEnum.BASE"
    ></app-number-input>
</div>
